import React from "react";
import ChartistGraph from "react-chartist";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  Image,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Label } from "reactstrap";
import { getAllTotalAreaManager } from "stores";
import { getAllTotalPengajuan } from "stores";
import ReactDatetime from "react-datetime";
import { getTotalPencairan } from "stores/Pengajuan/function";
import { getTotalPencairanProduktif } from "stores";
import { getGrafikPencairanCabang } from "stores";
import moment from "moment";
import LoadingModal from "./LoadingDashboard";

import { VictoryAxis } from "victory-axis";
import { VictoryBar } from "victory-bar";
import { VictoryChart } from "victory-chart";
import { VictoryLabel, VictoryTheme } from "victory-core";
import { VictoryGroup } from "victory-group";
import { VictoryPie } from "victory-pie";
import { VictoryTooltip } from "victory-tooltip";
import { VictoryVoronoiContainer } from "victory-voronoi-container";
import { getTotalTargetUser } from "stores/Pengajuan/function";
import { getGrafikPencairanUser } from "stores";
import { getAllTotalSupervisor } from "stores";
import { getAllTotalMarketing } from "stores";
import { getAllTotalCabang } from "stores";
import { getExportPengajuan } from "stores";
import { getExportPengajuanProduktif } from "stores";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getListManagementFee } from "stores";
import { getTotalTargetUserProduktif } from "stores";
import { getAllTotalPengajuanProduktif } from "stores";
import { getGrafikPencairanCabangProduktif } from "stores";
import { getGrafikPencairanUserProduktif } from "stores";
import { getAllTotalSupervisorProduktif } from "stores";
import { getAllTotalAreaManagerProduktif } from "stores";
import { getAllTotalMarketingProduktif } from "stores";
import { getAllTotalCabangProduktif } from "stores";
import { getAllWilayah } from "stores";

function DashboardUtama() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const cardTotalPengajuan = useSelector(
    (state) => state.dashboardUtamaReducer,
  );
  const cardTotalPengajuanProduktif = useSelector(
    (state) => state.dashboardUtamaProduktifReducer,
  );
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const pengajuanProduktif = useSelector(
    (state) => state.pengajuanProduktifReducer,
  );
  const managementFee = useSelector((state) => state.managementFeeReducer);
  // const ambilManagementFee = managementFee.listManagementFee;
  const tampilTotalPengajuan = useSelector(
    (state) => state.dashboardUtamaReducer.totalAllPengajuan,
  );
  const tampilTotalPengajuanProduktif = useSelector(
    (state) => state.dashboardUtamaProduktifReducer.totalAllPengajuanProduktif,
  );

  const [currentPage, setCurrentPage] = React.useState(1);
  const [modalExport, setModalExport] = React.useState(false);
  const [modalTotalPencairan, setModalTotalPencairan] = React.useState(false);
  const [modalMenunggu, setModalMenunggu] = React.useState(false);
  const [modalRevisi, setModalRevisi] = React.useState(false);
  const [modalDitolak, setModalDitolak] = React.useState(false);
  const [modalDiajukan, setModalDiajukan] = React.useState(false);
  const [modalDisetujui, setModalDisetujui] = React.useState(false);
  const [modalDiproses, setModalDiproses] = React.useState(false);
  const [modalDiajukanFileGagal, setModalDiajukanFileGagal] =
    React.useState(false);

  const itemsPerPage = 10;
  const [totalNominalPencairan, setTotalNominalPencairan] = React.useState(0);
  const [totalNominalBaru, setTotalNominalBaru] = React.useState(0);
  const [totalNominalKompensasi, setTotalNominalKompensasi] = React.useState(0);
  const [totalNominalTakeOver, setTotalNominalTakeOver] = React.useState(0);
  const [totalNominalPelunasan, setTotalNominalPelunasan] = React.useState(0);
  const [totalNominalTopUp, setTotalNominalTopUp] = React.useState(0);
  const [loadingPresentase, setLoadingPresentase] = React.useState(false);
  const [hasilPresentase, setHasilPresentase] = React.useState(0);
  const [totalNominalTarget, setTotalNominalTarget] = React.useState(0);
  const [dataGrafikCabang, setDataGrafikCabang] = React.useState([]);
  const [dataGrafikUser, setDataGrafikUser] = React.useState([]);
  const [totalSpv, setTotalSpv] = React.useState([]);
  const [totalCbg, setTotalCbg] = React.useState([]);
  const [totalAM, setTotalAM] = React.useState([]);
  const [totalMarketing, setTotalMarketing] = React.useState([]);
  const [dataAllGrafikCabang, setDataAllGrafikCabang] = React.useState([]);
  const [dariTgl, setDariTgl] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglManagementFee, setTglManagementFee] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [status, setStatus] = React.useState("");
  const [modalDetail, setModalDetail] = React.useState(false);
  const [smpTgl, setSmpTgl] = React.useState(new Date());
  const pencairanData = dataGrafikCabang.map((item) => item.totalPencairan);
  const targetData = dataGrafikCabang.map((item) => item.totalTarget);
  const [tahun, setTahun] = React.useState(new Date().getFullYear());
  let yearNow = new Date().getFullYear();
  const [listYear, setListYear] = React.useState([]);
  const [listDataMF, setListDataMF] = React.useState([]);
  const bulanData = dataGrafikUser.map((item) => item.bulan);
  const pencairanDataUser = dataGrafikUser.map(
    (item) => item.totalNominalPencairan,
  );
  const targetDataUser = dataGrafikUser.map((item) => item.totalNominalTarget);
  const abjadCabang = dataGrafikCabang.map((_, index) =>
    String.fromCharCode(65 + index),
  );
  const nominalBaruInBillion = totalNominalBaru / 1000000000;
  const nominalKompensasiInBillion = totalNominalKompensasi / 1000000000;
  const nominalPelunasanInBillion = totalNominalPelunasan / 1000000000;
  const nominalTakeOverInBillion = totalNominalTakeOver / 1000000000;
  const nominalTopUpInBillion = totalNominalTopUp / 1000000000;
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [loadingHalaman, setLoadingHalaman] = React.useState(true);
  const [listWilayah, setListWilayah] = React.useState([]);
  const [hoveredData, setHoveredData] = React.useState(null);
  const [tooltipPos, setTooltipPos] = React.useState({ x: 0, y: 0 });

  const [idWilayah, setIdWilayah] = React.useState({
    label: "All",
    value: "",
  });
  // ================================ state pilih kategori =========================================
  const listKategori = ["Konsumtif", "Produktif"];

  const capitalizeFirst = (str) => {
    if (!str || typeof str !== "string") return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const authAkses = (auth?.akses || []).map(capitalizeFirst);

  const kategori = auth?.akses || [];
  const isSuperAdmin =
    auth.role === "super admin" ||
    auth.role === "area manager" ||
    auth.role === "koordinator wilayah" ||
    auth.role === "admin" ||
    auth.role === "client";

  const hasFullAccess = isSuperAdmin || kategori?.length === 2;
  const aksesPertama = kategori?.[0];
  const loadings =
    !auth || (!isSuperAdmin && (!kategori || kategori.length === 0));

  const aksesUser = hasFullAccess
    ? listKategori.map((item) => ({
        label: capitalizeFirst(item),
        value: item,
      }))
    : (authAkses || []) // ini biar aman kalau kategori masih null
        .filter((item) => listKategori.includes(item)) // urutannya dibalik
        .map((item) => ({
          label: capitalizeFirst(item),
          value: item,
        }));

  const [pilihKategori, setPilihKategori] = React.useState(null);
  React.useEffect(() => {
    if (aksesUser.length > 0 && !pilihKategori) {
      setPilihKategori(aksesUser[0]);
    } else if (aksesUser.length === 0 && !pilihKategori) {
      // Fallback agar tidak null yang menyebabkan infinite skeleton
      setPilihKategori({ label: "Konsumtif", value: "Konsumtif" });
    }
  }, [aksesUser, pilihKategori]);

  // ================================ state produktif ===============================================
  React.useEffect(() => {
    getAllWilayah(dispatch).then((response) => {
      // const dataCabang = response.data;
      // setTotalCbg(dataCabang);
    });
  }, []);
  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(number);
  };

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
    setPage(0);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleExportPengajuan = () => {
    setStatus("");
    setTglAwal(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
        0,
        0,
        0,
        0,
      ),
    );
    setTglAkhir(new Date());
  };

  const closeModal = () => {
    setCurrentPage(1);
    setModalDetail(false);
    setModalTotalPencairan(false);
    setModalMenunggu(false);
    setModalRevisi(false);
    setModalDitolak(false);
    setModalDiajukan(false);
    setModalDiproses(false);
    setModalDisetujui(false);
    setModalDiajukanFileGagal(false);
  };

  const chartData = {
    labels: abjadCabang,
    series: [pencairanData, targetData],
  };

  const chartDataUser = {
    labels: bulanData,
    series: [pencairanDataUser, targetDataUser],
  };

  React.useEffect(() => {
    // setIsVisible(true);s
    getListYear();
  }, []);

  React.useEffect(() => {
    getAllTotalPengajuan(dispatch, { idWilayah: idWilayah.value });
  }, [idWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;
    if (pilihKategori?.value === "Konsumtif") {
      getAllTotalPengajuan(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
      });
    } else {
      getAllTotalPengajuanProduktif(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
      });
    }
  }, [dariTgl, smpTgl, pilihKategori]);

  const SDMBox = ({ title, val, icon, color }) => (
    <Col xs="6" className="p-2">
      <div
        className="p-3 rounded-lg text-center border"
        style={{ backgroundColor: "#f8fafc" }}
      >
        <i className={`fas fa-${icon} mb-2`} style={{ color: color }}></i>
        <small className="d-block text-muted fw-800 mb-1">{title}</small>
        <h5 className="m-0 font-weight-black text-dark">{val}</h5>
      </div>
    </Col>
  );

  const StatusCard = ({ title, val, color, onClick }) => (
    <div
      onClick={onClick}
      className="p-3 bg-white shadow-sm border-bottom border-4 rounded-xl text-center cursor-pointer hover-scale"
      style={{
        minWidth: "140px",
        borderBottom: `5px solid ${color}`,
        flex: "1",
      }}
    >
      <h3 className="m-0 font-weight-black" style={{ color: color }}>
        {val}
      </h3>
      <small className="fw-800 text-muted text-uppercase">{title}</small>
    </div>
  );

  const submitExport = async (e) => {
    e.preventDefault();
    if (pilihKategori?.value === "Konsumtif") {
      if (tglAwal === "" || tglAkhir === "" || status === "") {
        Swal.fire({
          title: "Semua Field Wajib Diisi",
          icon: "warning",
        });
        return;
      }

      Swal.fire({
        title: "Konfirmasi Export Pengajuan",
        text: `Apakah Anda ingin mengexport dari ${moment(tglAwal).format(
          "DD MMMM YYYY",
        )} sampai ${moment(tglAkhir).format("DD MMMM YYYY")} ?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, Export",
        cancelButtonText: "Batal",
        allowOutsideClick: () => !Swal.isLoading(),
        // showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            Swal.fire({
              title: "Sedang Mengexport, Ditunggu yaa..",
              allowOutsideClick: false,
              showConfirmButton: false,
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });
            // Meminta server untuk ekspor data
            const response = await getExportPengajuan({
              tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
              tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
              status: status.value,
            });

            // Mengaktifkan unduhan setelah menerima respons dari server
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Export Pengajuan ${status.value}.xlsx`,
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            Swal.close();
            // Tampilkan swal.fire setelah unduhan selesai
            Swal.fire({
              icon: "success",
              title: "Data berhasil diexport",
            });
          } catch (error) {
            Swal.fire({
              title: "Terjadi kesalahan",
              text: error.message,
              icon: "error",
            });
          }
        },
      });
    } else {
      Swal.fire({
        title: "Konfirmasi Export Pengajuan",
        text: `Apakah Anda ingin mengexport dari ${moment(tglAwal).format(
          "DD MMMM YYYY",
        )} sampai ${moment(tglAkhir).format("DD MMMM YYYY")} ?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, Export",
        cancelButtonText: "Batal",
        allowOutsideClick: () => !Swal.isLoading(),
        // showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            Swal.fire({
              title: "Sedang Mengexport, Ditunggu yaa..",
              allowOutsideClick: false,
              showConfirmButton: false,
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });
            // Meminta server untuk ekspor data
            const response = await getExportPengajuanProduktif({
              tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
              tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
              status: status.value,
            });

            // Mengaktifkan unduhan setelah menerima respons dari server
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Export Pengajuan ${status.value}.xlsx`,
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            Swal.close();
            // Tampilkan swal.fire setelah unduhan selesai
            Swal.fire({
              icon: "success",
              title: "Data berhasil diexport",
            });
          } catch (error) {
            Swal.fire({
              title: "Terjadi kesalahan",
              text: error.message,
              icon: "error",
            });
          }
        },
      });
    }
  };

  const getListYear = () => {
    let tmp = [];
    for (let i = 5; i >= 0; i--) {
      let years = yearNow--;
      tmp.push({
        value: years,
        label: years,
      });
    }
    setListYear(tmp);
  };

  React.useEffect(() => {
    let tmp = [{ value: "", label: "All" }];
    cardTotalPengajuan.allWilayah &&
      cardTotalPengajuan.allWilayah.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaWilayah,
        });
      });
    setListWilayah(tmp);
    let Obj = cardTotalPengajuan.allWilayah.find(
      (x) => x.namaWilayah === "kalsel",
    );
    // setIdWilayah({ value: Obj._id, label: Obj.namaWilayah });
    // console.log(Obj, ">>>>>>>>>>>>>>>>");
  }, [cardTotalPengajuan.allWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;
    if (pilihKategori?.value === "Konsumtif") {
      setLoadingPresentase(true);
      getTotalPencairan(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
        idWilayah: idWilayah.value,
      }).then((response) => {
        // console.log(response, "SSS");
        setLoadingPresentase(false);
        const totalPencairan = response.data.totalNominal;
        const totalBaru = response.data.baru;
        const totalKompensasi = response.data.kompensasi;
        const totalPelunasan = response.data.pelunasan;
        const totalTakeOver = response.data.takeOver;
        const totalTopUp = response.data.topup;
        setTotalNominalPencairan(totalPencairan);
        setTotalNominalBaru(totalBaru);
        setTotalNominalKompensasi(totalKompensasi);
        setTotalNominalPelunasan(totalPelunasan);
        setTotalNominalTakeOver(totalTakeOver);
        setTotalNominalTopUp(totalTopUp);
      });
    } else {
      setLoadingPresentase(true);
      getTotalPencairanProduktif(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
        idWilayah: idWilayah.value,
      }).then((response) => {
        // console.log(response, "SSS");
        setLoadingPresentase(false);
        const totalPencairan = response.data.totalNominal;
        const totalBaru = response.data.baru;
        const totalKompensasi = response.data.kompensasi;
        const totalPelunasan = response.data.pelunasan;
        const totalTakeOver = response.data.takeOver;
        const totalTopUp = response.data.topup;
        // console.log(totalBaru, "TOTA BARU");

        setTotalNominalPencairan(totalPencairan);
        setTotalNominalBaru(totalBaru);
        setTotalNominalKompensasi(totalKompensasi);
        setTotalNominalPelunasan(totalPelunasan);
        setTotalNominalTakeOver(totalTakeOver);
        setTotalNominalTopUp(totalTopUp);
      });
    }
  }, [dariTgl, smpTgl, pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;

    if (pilihKategori?.value === "Konsumtif") {
      getTotalTargetUser(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
        idWilayah: idWilayah.value,
      }).then((response) => {
        const totalTarget = response.data.totalTarget;
        setTotalNominalTarget(totalTarget);
      });
    } else {
      getTotalTargetUserProduktif(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
        idWilayah: idWilayah.value,
      }).then((response) => {
        const totalTarget = response.data.totalTarget;
        setTotalNominalTarget(totalTarget);
      });
    }
  }, [dariTgl, smpTgl, pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;
    if (pilihKategori?.value === "Konsumtif") {
      getGrafikPencairanCabang(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
        idWilayah: idWilayah.value,
      }).then((response) => {
        const grafikCabang = response.data;
        let tmp = [];
        grafikCabang.map((val, index) => {
          if (index < 15) {
            tmp.push(val);
          }
        });
        setDataGrafikCabang(tmp);
        setDataAllGrafikCabang(grafikCabang);
      });
    } else {
      getGrafikPencairanCabangProduktif(dispatch, {
        tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
        tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
        idWilayah: idWilayah.value,
      }).then((response) => {
        const grafikCabang = response.data;
        let tmp = [];
        grafikCabang.map((val, index) => {
          if (index < 15) {
            tmp.push(val);
          }
        });
        setDataGrafikCabang(tmp);
        setDataAllGrafikCabang(grafikCabang);
      });
    }
  }, [dariTgl, smpTgl, pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;
    if (pilihKategori?.value === "Konsumtif") {
      getGrafikPencairanUser(dispatch, {
        tahun: tahun,
        idWilayah: idWilayah.value,
      }).then((response) => {
        const grafikUser = response.data;
        setDataGrafikUser(grafikUser);
      });
    } else {
      getGrafikPencairanUserProduktif(dispatch, {
        tahun: tahun,
        idWilayah: idWilayah.value,
      }).then((response) => {
        const grafikUser = response.data;
        setDataGrafikUser(grafikUser);
      });
    }
  }, [tahun, pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (totalNominalTarget !== 0 && totalNominalPencairan !== 0) {
      const presentase = Math.round(
        (totalNominalPencairan / totalNominalTarget) * 100,
      );
      setHasilPresentase(presentase);
    } else {
      setHasilPresentase(0);
    }
  }, [totalNominalPencairan, totalNominalTarget]);

  const customStyles = {
    rows: {
      style: {
        height: 70, // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        //fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  const colCabangPencairan = [
    {
      name: "No",
      width: "70px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Nama Cabang",
      minWidth: "150px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Total Pencairan",
      minWidth: "200px",
      center: true,
      selector: (row) => {
        const formattedValue = row.totalPencairan.toLocaleString("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        });
        return `${formattedValue}`;
      },
    },
    {
      name: "Total Target",
      minWidth: "200px",
      center: true,
      selector: (row) => {
        const formattedValue = row.totalTarget.toLocaleString("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        });
        return `${formattedValue}`;
      },
    },
  ];

  React.useEffect(() => {
    if (managementFee.listManagementFee) {
      const tmp = managementFee.listManagementFee.map((val, index) => {
        return {
          ...val,
          action: <></>,
        };
      });
      setListDataMF(tmp);
    }
  }, [managementFee.listManagementFee]);

  const fmValues = managementFee.listManagementFee
    ? managementFee.listManagementFee.map((val) => Math.round(val.fm))
    : [];

  const items = [
    { title: "New", result: fmValues[0] || 0 },
    { title: "Top Up", result: fmValues[1] || 0 },
    { title: "Take Over", result: fmValues[2] || 0 },
    { title: "Kompensasi", result: fmValues[3] || 0 },
  ];

  const total = items.reduce((acc, item) => acc + item.result, 0);

  // =========== FM Produktif ========================
  const fmValuesProduktif = managementFee.listManagementFee
    ? managementFee.listManagementFee.map((val) => Math.round(val.fm))
    : [];

  const itemsProduktif = [
    { title: "New", result: 1 || 0 },
    { title: "Top Up", result: 1 || 0 },
    { title: "Take Over", result: 1 || 0 },
    { title: "Kompensasi", result: 1 || 0 },
  ];

  const totalProduktif = itemsProduktif.reduce(
    (acc, item) => acc + item.result,
    0,
  );

  React.useEffect(() => {
    setLoading(true);
    getListManagementFee(dispatch, {
      filterTgl: moment(tglManagementFee).format("YYYY-MM-DD"),
    })
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman, tglManagementFee]);

  const handleDateChange = (date) => {
    const newDate = date.toDate();
    newDate.setHours(0, 0, 0, 0);
    setTglManagementFee(
      new Date(newDate.getFullYear(), newDate.getMonth(), 1).getTime(),
    );
  };

  const CustomInput = ({ value, onClick }) => (
    <input
      type="text"
      className="form-control"
      value={moment(value).format("MMMM YYYY")}
      onClick={onClick}
      readOnly
      style={{ cursor: "default", color: "black", backgroundColor: "white" }}
    />
  );

  React.useEffect(() => {
    if (!pilihKategori) return;
    if (pilihKategori?.value === "Konsumtif") {
      getAllTotalSupervisor(dispatch, { idWilayah: idWilayah.value }).then(
        (response) => {
          const dataSupervisor = response.data;
          setTotalSpv(dataSupervisor);
        },
      );
    } else {
      getAllTotalSupervisorProduktif(dispatch, {
        idWilayah: idWilayah.value,
      }).then((response) => {
        const dataSupervisor = response.data;
        setTotalSpv(dataSupervisor);
      });
    }
  }, [pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;
    if (pilihKategori?.value === "Konsumtif") {
      getAllTotalAreaManager(dispatch, { idWilayah: idWilayah.value }).then(
        (response) => {
          const dataAreaManager = response.data;
          setTotalAM(dataAreaManager);
        },
      );
    } else {
      getAllTotalAreaManagerProduktif(dispatch, {
        idWilayah: idWilayah.value,
      }).then((response) => {
        const dataAreaManager = response.data;
        setTotalAM(dataAreaManager);
      });
    }
  }, [pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;

    if (pilihKategori?.value === "Konsumtif") {
      getAllTotalMarketing(dispatch, { idWilayah: idWilayah.value }).then(
        (response) => {
          const dataMarketing = response.data;
          setTotalMarketing(dataMarketing);
        },
      );
    } else {
      getAllTotalMarketingProduktif(dispatch, {
        idWilayah: idWilayah.value,
      }).then((response) => {
        const dataMarketing = response.data;
        setTotalMarketing(dataMarketing);
      });
    }
  }, [pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (!pilihKategori) return;

    if (pilihKategori?.value === "Konsumtif") {
      getAllTotalCabang(dispatch, { idWilayah: idWilayah.value }).then(
        (response) => {
          const dataCabang = response.data;
          setTotalCbg(dataCabang);
        },
      );
    } else {
      getAllTotalCabangProduktif(dispatch, { idWilayah: idWilayah.value }).then(
        (response) => {
          const dataCabang = response.data;
          setTotalCbg(dataCabang);
        },
      );
    }
  }, [pilihKategori, idWilayah]);

  React.useEffect(() => {
    if (auth.role === "client") {
      const interval = setInterval(() => {
        window.location.reload();
        refresh();
      }, 300000);

      return () => clearInterval(interval);
    }
  }, [auth.role]);

  return (
    <>
      {/* =========================================================================
          1. GROUP MODAL DETAIL STATUS: MENUNGU, REVISI, DITOLAK, DIPROSES, DISETUJUI, GAGAL FILE
          ========================================================================= */}
      {[
        {
          id: modalDiajukanFileGagal,
          title: "Detail Gagal File",
          subTitle: "Berkas pengajuan yang gagal validasi sistem",
          fieldBaru: "diajukanBaruGagalFile",
          fieldKompensasi: "diajukanKompensasiGagalFile",
          fieldPelunasan: "diajukanPelunasanGagalFile",
          fieldTakeOver: "diajukanTakeOverGagalFile",
          fieldTopUp: "diajukanTopupGagalFile",
          theme: "#E10F00",
        },
        {
          id: modalMenunggu,
          title: "Detail Berkas Menunggu",
          subTitle: "Antrean berkas masuk yang menunggu verifikasi",
          fieldBaru: "menungguBaru",
          fieldKompensasi: "menungguKompensasi",
          fieldPelunasan: "menungguPelunasan",
          fieldTakeOver: "menungguTakeOver",
          fieldTopUp: "menungguTopup",
          theme: "#FFAF05",
        },
        {
          id: modalRevisi,
          title: "Detail Berkas Revisi",
          subTitle: "Daftar berkas yang harus diperbaiki oleh marketing",
          fieldBaru: "revisiBaru",
          fieldKompensasi: "revisiKompensasi",
          fieldPelunasan: "revisiPelunasan",
          fieldTakeOver: "revisiTakeOver",
          fieldTopUp: "revisiTopup",
          theme: "#FF2B4B",
        },
        {
          id: modalDitolak,
          title: "Detail Berkas Ditolak",
          subTitle: "Berkas pengajuan yang tidak memenuhi syarat kriteria",
          fieldBaru: "ditolakBaru",
          fieldKompensasi: "ditolakKompensasi",
          fieldPelunasan: "ditolakPelunasan",
          fieldTakeOver: "ditolakTakeOver",
          fieldTopUp: "ditolakTopup",
          theme: "#E10F00",
        },
        {
          id: modalDiajukan,
          title: "Detail Berkas Diajukan",
          subTitle: "Total berkas yang berhasil masuk ke sistem hub",
          fieldBaru: "diajukanBaru",
          fieldKompensasi: "diajukanKompensasi",
          fieldPelunasan: "diajukanPelunasan",
          fieldTakeOver: "diajukanTakeOver",
          fieldTopUp: "diajukanTopup",
          theme: "#2F5597",
        },
        {
          id: modalDiproses,
          title: "Detail Berkas Diproses",
          subTitle: "Berkas aktif yang sedang direview oleh analis",
          fieldBaru: "prosesBaru",
          fieldKompensasi: "prosesKompensasi",
          fieldPelunasan: "prosesPelunasan",
          fieldTakeOver: "prosesTakeOver",
          fieldTopUp: "prosesTopup",
          theme: "#2F5597",
        },
        {
          id: modalDisetujui,
          title: "Detail Berkas Disetujui",
          subTitle: "Komposisi pengajuan yang sukses disetujui",
          fieldBaru: "disetujuiBaru",
          fieldKompensasi: "disetujuiKompensasi",
          fieldPelunasan: "disetujuiPelunasan",
          fieldTakeOver: "disetujuiTakeOver",
          fieldTopUp: "disetujuiTopup",
          theme: "#26DB53",
        },
      ].map((m, idx) => (
        <Modal
          key={idx}
          size="md"
          show={m.id}
          onHide={closeModal}
          centered
          style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
        >
          <div
            style={{
              borderRadius: "20px",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <Modal.Header closeButton className="border-0 pt-4 px-4 pb-2">
              <Modal.Title className="w-100 text-center">
                <span
                  className="d-block text-dark tracking-tight mb-1"
                  style={{ fontSize: "18px", fontWeight: "900" }}
                >
                  {m.title}
                </span>
                <small
                  className="text-muted d-block font-weight-normal"
                  style={{ fontSize: "12px" }}
                >
                  {m.subTitle}
                </small>
                <div
                  className="mx-auto mt-3"
                  style={{
                    width: "40px",
                    height: "4px",
                    backgroundColor: m.theme,
                    borderRadius: "2px",
                  }}
                ></div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
              {/* Grid Bento Content */}
              <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                {[
                  {
                    label: "New / Baru",
                    color: m.theme,
                    val:
                      pilihKategori?.value === "Konsumtif"
                        ? cardTotalPengajuan.totalPengajuan?.data?.[m.fieldBaru]
                        : cardTotalPengajuanProduktif.totalPengajuanProduktif
                            ?.data?.[m.fieldBaru],
                  },
                  {
                    label: "Kompensasi",
                    color: "#334155",
                    val:
                      pilihKategori?.value === "Konsumtif"
                        ? cardTotalPengajuan.totalPengajuan?.data?.[
                            m.fieldKompensasi
                          ]
                        : cardTotalPengajuanProduktif.totalPengajuanProduktif
                            ?.data?.[m.fieldKompensasi],
                  },
                  {
                    label: "Pelunasan",
                    color: "#334155",
                    val:
                      pilihKategori?.value === "Konsumtif"
                        ? cardTotalPengajuan.totalPengajuan?.data?.[
                            m.fieldPelunasan
                          ]
                        : cardTotalPengajuanProduktif.totalPengajuanProduktif
                            ?.data?.[m.fieldPelunasan],
                  },
                  {
                    label: "Take Over",
                    color: "#334155",
                    val:
                      pilihKategori?.value === "Konsumtif"
                        ? cardTotalPengajuan.totalPengajuan?.data?.[
                            m.fieldTakeOver
                          ]
                        : cardTotalPengajuanProduktif.totalPengajuanProduktif
                            ?.data?.[m.fieldTakeOver],
                  },
                  {
                    label: "Top Up",
                    color: "#334155",
                    val:
                      pilihKategori?.value === "Konsumtif"
                        ? cardTotalPengajuan.totalPengajuan?.data?.[
                            m.fieldTopUp
                          ]
                        : cardTotalPengajuanProduktif.totalPengajuanProduktif
                            ?.data?.[m.fieldTopUp],
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex-fill bg-light p-3 text-center position-relative"
                    style={{
                      borderRadius: "12px",
                      minWidth: "120px",
                      border: "1px solid #F1F5F9",
                    }}
                  >
                    <span
                      className="d-block m-0"
                      style={{
                        fontSize: "22px",
                        fontWeight: "900",
                        color: item.color,
                      }}
                    >
                      {item.val ?? 0}
                    </span>
                    <small
                      className="text-secondary text-uppercase font-weight-bold tracking-wider mt-1 d-block"
                      style={{ fontSize: "9.5px" }}
                    >
                      {item.label}
                    </small>
                  </div>
                ))}
              </div>
            </Modal.Body>
          </div>
        </Modal>
      ))}

      {/* =========================================================================
          2. MODAL TOTAL PENCAIRAN (METRICS WITH INTERNAL VICTORY BAR)
          ========================================================================= */}
      <Modal
        size="lg"
        show={modalTotalPencairan}
        onHide={closeModal}
        centered
        style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
      >
        <div
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <Modal.Header closeButton className="border-0 pt-4 px-4 pb-2">
            <Modal.Title className="w-100 text-center">
              <span
                className="d-block text-dark tracking-tight mb-1"
                style={{ fontSize: "19px", fontWeight: "900" }}
              >
                <i className="fas fa-wallet text-info mr-2"></i>Rincian
                Distribusi Nominal Pencairan
              </span>
              <small
                className="text-muted d-block font-weight-normal"
                style={{ fontSize: "12px" }}
              >
                Komposisi nilai nominal realisasi efektif berdasarkan jenis
                pengajuan kredit
              </small>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {/* Bento Grid Info Rupiah */}
            <div className="d-flex flex-wrap mb-4" style={{ gap: "10px" }}>
              {[
                {
                  label: "Total Baru",
                  val: totalNominalBaru,
                  color: "#003A70",
                },
                {
                  label: "Total Kompensasi",
                  val: totalNominalKompensasi,
                  color: "#475569",
                },
                {
                  label: "Total Pelunasan",
                  val: totalNominalPelunasan,
                  color: "#475569",
                },
                {
                  label: "Total Take Over",
                  val: totalNominalTakeOver,
                  color: "#475569",
                },
                {
                  label: "Total Top Up",
                  val: totalNominalTopUp,
                  color: "#475569",
                },
              ].map((nom, idx) => (
                <div
                  key={idx}
                  className="flex-fill bg-light p-3 border"
                  style={{
                    borderRadius: "14px",
                    minWidth: "180px",
                    borderColor: "#E2E8F0",
                  }}
                >
                  <small
                    className="text-muted text-uppercase font-weight-bold tracking-wider mb-1 d-block"
                    style={{ fontSize: "9px" }}
                  >
                    {nom.label}
                  </small>
                  <span
                    className="d-block text-dark"
                    style={{ fontSize: "14px", fontWeight: "800" }}
                  >
                    {formatRupiah(nom.val)}
                  </span>
                </div>
              ))}
            </div>

            {/* Container Grafik Clean */}
            <div
              className="p-3 border text-center"
              style={{
                borderRadius: "16px",
                backgroundColor: "#F8FAFC",
                borderColor: "#E2E8F0",
              }}
            >
              <h6
                className="m-0 mb-3 text-secondary text-uppercase"
                style={{
                  fontSize: "11px",
                  fontWeight: "800",
                  letterSpacing: "0.5px",
                }}
              >
                <i className="fas fa-chart-bar mr-2 text-primary"></i>
                Visualisasi Perbandingan (Miliar IDR)
              </h6>
              <div className="d-flex justify-content-center">
                <VictoryChart
                  domainPadding={{ x: 45 }}
                  width={650}
                  height={260}
                  style={{ parent: { maxWidth: "100%" } }}
                >
                  <VictoryBar
                    data={[
                      { category: "Baru", value: nominalBaruInBillion },
                      {
                        category: "Kompensasi",
                        value: nominalKompensasiInBillion,
                      },
                      {
                        category: "Pelunasan",
                        value: nominalPelunasanInBillion,
                      },
                      {
                        category: "Take Over",
                        value: nominalTakeOverInBillion,
                      },
                      { category: "Top Up", value: nominalTopUpInBillion },
                    ]}
                    x="category"
                    y="value"
                    barWidth={18}
                    style={{
                      data: { fill: "#003A70", rx: 4, ry: 4 },
                      labels: {
                        fontSize: 10,
                        fill: "#475569",
                        fontWeight: "700",
                      },
                    }}
                    labels={({ datum }) =>
                      datum.value > 0 ? `${datum.value.toFixed(1)} M` : ""
                    }
                  />
                  <VictoryAxis
                    style={{
                      tickLabels: {
                        fontSize: "11px",
                        fontFamily: "inherit",
                        fontWeight: "600",
                        fill: "#334155",
                      },
                      axis: { stroke: "#CBD5E1" },
                    }}
                  />
                  <VictoryAxis
                    dependentAxis
                    tickCount={5}
                    style={{
                      tickLabels: { fontSize: "10px", fill: "#64748B" },
                      axis: { stroke: "#CBD5E1" },
                      grid: { stroke: "#E2E8F0" },
                    }}
                    domain={
                      [
                        nominalBaruInBillion,
                        nominalKompensasiInBillion,
                        nominalPelunasanInBillion,
                        nominalTakeOverInBillion,
                        nominalTopUpInBillion,
                      ].some((value) => value !== 0)
                        ? undefined
                        : { y: [0, 1] }
                    }
                  />
                </VictoryChart>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* =========================================================================
          4. MODAL DETAIL DATA TABEL CABANG (FULL WIDTH DATATABLE COMPONENT)
          ========================================================================= */}
      <Modal
        size="lg"
        show={modalDetail}
        onHide={closeModal}
        centered
        style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
      >
        <div
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <Modal.Header closeButton className="border-0 pt-4 px-4 pb-1">
            <Modal.Title>
              <span
                className="d-block text-dark"
                style={{ fontSize: "18px", fontWeight: "900" }}
              >
                <i className="fas fa-university text-primary mr-2"></i>Detail
                Data Cabang Pencairan
              </span>
              <small
                className="text-muted font-weight-normal d-block mt-1"
                style={{ fontSize: "12px" }}
              >
                Tabulasi rincian data pencairan realisasi kerja pada
                masing-masing unit kantor cabang bank kalbar
              </small>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div
              className="border"
              style={{ borderRadius: "14px", overflow: "hidden" }}
            >
              <DataTable
                columns={colCabangPencairan}
                data={dataAllGrafikCabang}
                customStyles={customStyles}
                pagination
                paginationPerPage={itemsPerPage}
                onChangePage={handlePageChange}
              />
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* =========================================================================
          3. MODAL EXPORT FORM PANEL (CLEAN & FINTECH STYLE FORM)
          ========================================================================= */}
      <Modal
        size="lg"
        show={modalExport}
        onHide={() => setModalExport(false)}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            backgroundColor: "#F8F9FC",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        />

        <Modal.Body
          style={{
            backgroundColor: "#F8F9FC",
            padding: "0 40px 40px 40px",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#10b981",
                borderRadius: "20px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(16, 185, 129, 0.2)",
                marginBottom: "15px",
              }}
            >
              <i className="fas fa-file-excel fa-2x text-white"></i>
            </div>
            <h3
              style={{
                fontWeight: "800",
                color: "#1e293b",
                marginBottom: "5px",
              }}
            >
              Export Data Pengajuan
            </h3>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Silahkan pilih filter data yang ingin Anda unduh
            </p>
          </div>

          <Form className="form">
            <Card
              style={{
                border: "none",
                borderRadius: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
              }}
            >
              <Card.Body className="p-4">
                <Row>
                  {/* TANGGAL AWAL */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="far fa-calendar-alt mr-2 text-primary"></i>{" "}
                        Tanggal Awal
                      </label>
                      <ReactDatetime
                        inputProps={{
                          className: "form-control border-0 bg-light p-3",
                          placeholder: "Mulai Dari",
                          readOnly: true,
                          style: {
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "15px",
                          },
                        }}
                        onChange={(e) =>
                          setTglAwal(e.toDate().setHours(0, 0, 0, 0))
                        }
                        value={tglAwal}
                        timeFormat={false}
                      />
                    </Form.Group>
                  </Col>

                  {/* TANGGAL AKHIR */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="far fa-calendar-check mr-2 text-primary"></i>{" "}
                        Tanggal Akhir
                      </label>
                      <ReactDatetime
                        inputProps={{
                          className: "form-control border-0 bg-light p-3",
                          placeholder: "Sampai Dengan",
                          readOnly: true,
                          style: {
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "15px",
                          },
                        }}
                        onChange={(e) =>
                          setTglAkhir(e.toDate().setHours(23, 59, 59, 999))
                        }
                        value={tglAkhir}
                        timeFormat={false}
                      />
                    </Form.Group>
                  </Col>

                  {/* STATUS */}
                  <Col md="12" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-info-circle mr-2 text-primary"></i>{" "}
                        Status Pengajuan
                      </label>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        onChange={(value) => setStatus(value)}
                        options={[
                          { value: "Semua", label: "Semua Pengajuan" },
                          { value: "Disetujui", label: "Disetujui" },
                          { value: "Diproses", label: "Diproses" },
                          { value: "Diajukan", label: "Diajukan" },

                          {
                            value: "Menunggu Konfirmasi",
                            label: "Menunggu Konfirmasi",
                          },
                          { value: "Revisi", label: "Revisi" },
                          { value: "Ditolak", label: "Ditolak" },
                        ]}
                        placeholder="Pilih Status"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="mt-4">
                  <Button
                    className="btn-block p-3"
                    style={{
                      border: "none",
                      backgroundColor: "#10b981",
                      boxShadow: "0 10px 20px rgba(16, 185, 129, 0.3)",
                      borderRadius: "15px",
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                    onClick={submitExport}
                  >
                    <i className="fas fa-file-download mr-2"></i> UNDUH LAPORAN
                    EXCEL
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
      </Modal>

      <Card
        className="border-0 shadow-sm"
        style={{
          borderRadius: "24px",
          backgroundColor: "#F4F7FE",
          overflow: "hidden",
        }}
      >
        <Container fluid className="p-4">
          {/* =========================================================================
        1 & 2. THE ULTIMATE TOP PANEL (LOGO + PERIODE + 3-IN-1 METRICS IN ONE BOX)
        ========================================================================= */}
          <Row className="mb-4">
            <Col md="12">
              <div
                className="p-4 text-white shadow-lg position-relative"
                style={{
                  background:
                    "linear-gradient(135deg, #001226 0%, #002D59 50%, #004080 100%)",
                  borderRadius: "24px",
                }}
              >
                {/* TOP INNER ROW: BRANDING IDENTITY & ACTION CONTROLS */}
                <Row
                  className="align-items-center pb-4 mb-4 border-bottom"
                  style={{ borderColor: "rgba(255, 255, 255, 0.12)" }}
                >
                  {/* Left Column: Brand Box */}
                  <Col
                    xl="5"
                    lg="12"
                    className="d-flex flex-column flex-sm-row align-items-center text-center text-sm-left mb-3 xl-mb-0"
                  >
                    {/* Grand Logo Frame Box */}
                    <div
                      className="d-flex align-items-center justify-content-center bg-white mb-3 mb-sm-0 mr-sm-4 p-2 container-logo-glow"
                      style={{
                        width: "50%",
                        height: "150px",
                        borderRadius: "16px",
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/3/35/Logo_Bank_Kalbar.png"
                        alt="Bank Kalbar Logo"
                        style={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    {/* Text Identity Hub */}
                    <div>
                      <span
                        className="badge px-2 py-1 text-uppercase mb-2 font-weight-bold"
                        style={{
                          backgroundColor: "rgba(255, 179, 0, 0.2)",
                          color: "#FFD066",
                          fontSize: "10px",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Official Monitoring Hub
                      </span>
                      <h4
                        className="m-0 text-uppercase tracking-tight"
                        style={{
                          fontSize: "20px",
                          fontWeight: "900",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        BAP MONITORING{" "}
                        <span style={{ color: "#FFB300" }}>
                          {pilihKategori?.label || "SYSTEM"}
                        </span>
                      </h4>
                      <p
                        className="m-0 small mt-1 text-white-50"
                        style={{ fontWeight: "600" }}
                      >
                        <i className="fas fa-university mr-1 text-white-50"></i>{" "}
                        PT Bank Pembangunan Daerah Kalimantan Barat
                      </p>
                    </div>
                  </Col>

                  {/* Right Column: INTEGRATED DATE FILTER & EXPORT BUTTON */}
                  <Col
                    xl="7"
                    lg="12"
                    className="d-flex flex-column align-items-center align-items-xl-end justify-content-between pt-2"
                    style={{ minHeight: "150px" }} // Memberikan space vertikal agar tombol terdorong ke pojok bawah
                  >
                    {/* POJOK KANAN ATAS: Pemilihan Periode Tanggal */}
                    {(auth.role === "super admin" ||
                      auth.role === "admin" ||
                      auth.role === "client") && (
                      <Button
                        className="px-4 py-2 border-0 text-white font-weight-bold btn-vibrant-glow mt-3 mt-xl-0"
                        onClick={() =>
                          !loadingPresentase && setModalExport(true)
                        }
                        style={{
                          background:
                            "linear-gradient(135deg, #0DC3A4 0%, #0AA88D 100%)",
                          borderRadius: "12px",
                          fontSize: "13px",
                          height: "38px",
                        }}
                        disabled={loadingPresentase}
                      >
                        <i className="fas fa-file-excel mr-2"></i> EXPORT EXCEL
                      </Button>
                    )}
                    <div className="mb-3">
                      <label
                        className="font-weight-bold mb-2"
                        style={{ fontSize: "13px", color: "#cbd5e1" }}
                      >
                        DARI TANGGAL
                      </label>
                      <div className="rdt-static">
                        <ReactDatetime
                          inputProps={{
                            className:
                              "form-control border-0 bg-white text-dark text-center p-4",
                            style: {
                              borderRadius: "12px",
                              fontWeight: "900",
                              fontSize: "16px",
                              cursor: "pointer",
                            },
                            readOnly: true,
                          }}
                          onChange={(e) =>
                            setDariTgl(e.toDate().setHours(0, 0, 0, 0))
                          }
                          value={dariTgl}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </div>
                    </div>

                    <div>
                      <label
                        className="font-weight-bold mb-2"
                        style={{ fontSize: "13px", color: "#cbd5e1" }}
                      >
                        SAMPAI TANGGAL
                      </label>
                      <div className="rdt-static">
                        <ReactDatetime
                          inputProps={{
                            className:
                              "form-control border-0 bg-white text-dark text-center p-4",
                            style: {
                              borderRadius: "12px",
                              fontWeight: "900",
                              fontSize: "16px",
                              cursor: "pointer",
                            },
                            readOnly: true,
                          }}
                          onChange={(e) =>
                            setSmpTgl(e.toDate().setHours(23, 59, 0, 0))
                          }
                          value={smpTgl}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </div>
                    </div>
                    <style>{`
  /* CONTAINER UTAMA KALENDER */
  .rdtPicker {
    display: block !important;
    position: absolute !important;
    background-color: #ffffff !important; /* Putih bersih */
    border: 1px solid #e2e8f0 !important;
    border-radius: 16px !important;
    box-shadow: 0 20px 40px rgba(0,0,0,0.25) !important;
    margin-top: 10px !important;
    padding: 15px !important;
    width: 260px !important;
    z-index: 999999 !important;
    color: #1e293b !important; /* PASTI HITAM PEKAT */
  }

  /* WARNA TEKS HARI & ANGKA (AGAR TIDAK PUTIH) */
  .rdt th, .rdt td, .rdt span {
    color: #1e293b !important; /* Warna teks gelap agar kelihatan */
    font-size: 13px !important;
    padding: 5px !important;
    text-align: center !important;
  }

  /* WARNA HARI LIBUR / LUAR BULAN */
  .rdtOld, .rdtNew {
    color: #cbd5e1 !important; /* Abu-abu muda */
  }

  /* HEADER (BULAN & TAHUN) */
  .rdtSwitch {
    font-weight: 800 !important;
    color: #1e293b !important;
    cursor: pointer !important;
  }
  .rdtSwitch:hover { background: #f1f5f9 !important; }

  /* TOMBOL PANAH (PREV/NEXT) */
  .rdtPrev span, .rdtNext span {
    color: #1e293b !important;
    font-size: 18px !important;
    font-weight: bold !important;
  }

  /* SAAT HOVER HARI */
  .rdtDay:hover {
    background-color: #3b82f6 !important;
    color: white !important;
    border-radius: 8px !important;
    cursor: pointer !important;
  }

  /* HARI YANG DIPILIH (ACTIVE) */
  .rdtActive {
    background-color: #1e293b !important;
    color: white !important;
    border-radius: 8px !important;
  }

  /* HARI INI (TODAY) */
  .rdtToday:before {
    border-bottom: 7px solid #3b82f6 !important;
  }

  /* HACK AGAR TIDAK TERPOTONG CARD */
  .card {
    overflow: visible !important;
  }
`}</style>
                  </Col>
                </Row>

                {/* BOTTOM INNER ROW: METRICS DISPLAY (THE TRIO METRICS) */}
                <Row className="text-center text-sm-left">
                  {/* 1. Persentase Realisasi */}
                  <Col sm="4" className="border-sm-right mb-4 mb-sm-0">
                    <div className="d-flex align-items-center justify-content-center justify-content-sm-start mb-2 opacity-75">
                      <i className="fas fa-percentage mr-2 text-gold"></i>
                      <small
                        className="font-weight-bold text-uppercase tracking-wider"
                        style={{ fontSize: "10px" }}
                      >
                        Persentase Realisasi
                      </small>
                    </div>
                    {loadingPresentase ? (
                      <Skeleton height={35} width={80} />
                    ) : (
                      <h1
                        className="m-0"
                        style={{
                          fontWeight: "900",
                          fontSize: "2.5rem",
                          color: hasilPresentase > 100 ? "#26DB53" : "#FFB300",
                        }}
                      >
                        {hasilPresentase}%
                      </h1>
                    )}
                    <small className="text-white-50 d-block mt-1">
                      Target Batas Keberhasilan: 100%
                    </small>
                  </Col>

                  {/* 2. Total Nominal Pencairan */}
                  <Col sm="4" className="border-sm-right mb-4 mb-sm-0 pl-sm-4">
                    <div className="d-flex align-items-center justify-content-center justify-content-sm-start mb-2 opacity-75">
                      <i className="fas fa-wallet mr-2 text-info"></i>
                      <small
                        className="font-weight-bold text-uppercase tracking-wider"
                        style={{ fontSize: "10px" }}
                      >
                        Total Nominal Pencairan
                      </small>
                      <i
                        className="fas fa-external-link-alt text-gold small ml-2 cursor-pointer icon-click-effect"
                        onClick={() =>
                          !loadingPresentase &&
                          setModalTotalPencairan(!modalTotalPencairan)
                        }
                      ></i>
                    </div>
                    <h3
                      className="m-0 text-white font-weight-bold truncate-text"
                      style={{ fontWeight: "900", fontSize: "1.65rem" }}
                    >
                      {pilihKategori?.value === "Konsumtif" ? (
                        pengajuan.totalPencairan.length === 0 ? (
                          <Skeleton width={120} />
                        ) : (
                          formatRupiah(pengajuan.totalPencairan)
                        )
                      ) : pengajuanProduktif.totalPencairanProduktif.length ===
                        0 ? (
                        <Skeleton width={120} />
                      ) : (
                        formatRupiah(pengajuanProduktif.totalPencairanProduktif)
                      )}
                    </h3>
                    <small className="text-white-50 d-block mt-1">
                      Volume Realisasi Efektif
                    </small>
                  </Col>

                  {/* 3. Target Nominal Kerja */}
                  <Col sm="4" className="pl-sm-4">
                    <div className="d-flex align-items-center justify-content-center justify-content-sm-start mb-2 opacity-75">
                      <i className="fas fa-bullseye mr-2 text-danger"></i>
                      <small
                        className="font-weight-bold text-uppercase tracking-wider"
                        style={{ fontSize: "10px" }}
                      >
                        Target Nominal Kerja
                      </small>
                    </div>
                    <h3
                      className="m-0 text-white font-weight-bold truncate-text"
                      style={{ fontWeight: "900", fontSize: "1.65rem" }}
                    >
                      {pilihKategori?.value === "Konsumtif" ? (
                        pengajuan.totalPencairan.length === 0 ? (
                          <Skeleton width={120} />
                        ) : (
                          formatRupiah(
                            pengajuan.listTotalTargetUser.totalTarget,
                          )
                        )
                      ) : pengajuanProduktif.totalPencairanProduktif.length ===
                        0 ? (
                        <Skeleton width={120} />
                      ) : (
                        formatRupiah(
                          pengajuanProduktif.listTotalTargetUserProduktif
                            .totalTarget,
                        )
                      )}
                    </h3>
                    <small className="text-white-50 d-block mt-1">
                      Akumulasi Target Korporat
                    </small>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {/* =========================================================================
        4. THE COMMAND CENTER CARD (COMBINED: STAFF GRID & PIPELINE TRACKER STRIPS)
        ========================================================================= */}
          <Row className="mb-4">
            <Col md="12">
              <div
                className="bg-white p-4 shadow-xs"
                style={{ borderRadius: "24px" }}
              >
                <Row className="align-items-stretch">
                  {/* =========================================================================
            LEFT SIDE: COMPOSITION SDM LAPANGAN (NO EMPTY SPACE & HEAVY BOLD)
            ========================================================================= */}
                  <Col
                    xl="5"
                    lg="12"
                    className="border-xl-right pr-xl-4 mb-4 xl-mb-0 d-flex flex-column justify-content-between"
                  >
                    <div className="mb-4 text-center text-xl-left">
                      <h5
                        className="m-0 text-dark text-uppercase tracking-tight"
                        style={{
                          fontSize: "14px",
                          fontWeight: "900",
                          letterSpacing: "0.5px",
                        }}
                      >
                        <i className="fas fa-users text-primary mr-2"></i>
                        Komposisi SDM Lapangan
                      </h5>
                      <small
                        className="text-muted"
                        style={{
                          fontWeight: "700",
                          display: "block",
                          marginTop: "2px",
                        }}
                      >
                        Akumulasi sebaran tim manajemen & marketing aktif di
                        lapangan
                      </small>
                    </div>

                    {/* Bento box sdm dibuat memenuhi ruang vertikal secara seimbang */}
                    <div
                      className="d-flex flex-wrap text-center flex-grow-1 align-items-center"
                      style={{ gap: "12px" }}
                    >
                      <div
                        className="flex-fill bg-light p-3 card-sdm-zoom shadow-xxs"
                        style={{ borderRadius: "14px", minWidth: "85px" }}
                      >
                        <span
                          className="d-block text-primary m-0"
                          style={{
                            fontSize: "26px",
                            fontWeight: "900",
                            lineHeight: "1.1",
                          }}
                        >
                          {totalAM.totalAm}
                        </span>
                        <small
                          className="text-dark text-uppercase d-block mt-2"
                          style={{
                            fontSize: "10px",
                            fontWeight: "900",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Area Mgr
                        </small>
                      </div>

                      <div
                        className="flex-fill bg-light p-3 card-sdm-zoom shadow-xxs"
                        style={{ borderRadius: "14px", minWidth: "85px" }}
                      >
                        <span
                          className="d-block text-success m-0"
                          style={{
                            fontSize: "26px",
                            fontWeight: "900",
                            lineHeight: "1.1",
                          }}
                        >
                          {totalSpv.totalSpv}
                        </span>
                        <small
                          className="text-dark text-uppercase d-block mt-2"
                          style={{
                            fontSize: "10px",
                            fontWeight: "900",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Supervisor
                        </small>
                      </div>

                      <div
                        className="flex-fill bg-light p-3 card-sdm-zoom shadow-xxs"
                        style={{ borderRadius: "14px", minWidth: "85px" }}
                      >
                        <span
                          className="d-block text-warning m-0"
                          style={{
                            fontSize: "26px",
                            fontWeight: "900",
                            lineHeight: "1.1",
                          }}
                        >
                          {totalMarketing.totalSm}
                        </span>
                        <small
                          className="text-dark text-uppercase d-block mt-2"
                          style={{
                            fontSize: "10px",
                            fontWeight: "900",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Marketing
                        </small>
                      </div>

                      {(auth.role === "admin" ||
                        auth.role === "super admin") && (
                        <div
                          className="flex-fill p-3 card-sdm-zoom"
                          style={{
                            borderRadius: "14px",
                            backgroundColor: "rgba(13, 202, 240, 0.08)",
                            border: "1px solid rgba(13, 202, 240, 0.25)",
                            minWidth: "85px",
                          }}
                        >
                          <span
                            className="d-block text-info m-0"
                            style={{
                              fontSize: "26px",
                              fontWeight: "900",
                              lineHeight: "1.1",
                            }}
                          >
                            {totalMarketing.totalLogin}
                          </span>
                          <small
                            className="text-info text-uppercase d-block mt-2"
                            style={{
                              fontSize: "10px",
                              fontWeight: "900",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Active Log
                          </small>
                        </div>
                      )}

                      <div
                        className="flex-fill bg-dark p-3 card-sdm-zoom text-white shadow-xxs"
                        style={{ borderRadius: "14px", minWidth: "85px" }}
                      >
                        <span
                          className="d-block text-gold m-0"
                          style={{
                            fontSize: "26px",
                            fontWeight: "900",
                            lineHeight: "1.1",
                          }}
                        >
                          {totalCbg.totalCabang}
                        </span>
                        <small
                          className="text-white text-uppercase d-block mt-2"
                          style={{
                            fontSize: "10px",
                            fontWeight: "900",
                            letterSpacing: "0.5px",
                            color: "#FFD066",
                          }}
                        >
                          Cabang
                        </small>
                      </div>
                    </div>
                  </Col>

                  {/* =========================================================================
            RIGHT SIDE: WORKFLOW TRACKERS STRIPS (SUPER BOLD EDITION)
            ========================================================================= */}
                  <Col
                    xl="7"
                    lg="12"
                    className="pl-xl-4 d-flex flex-column justify-content-between mt-4 mt-xl-0"
                  >
                    <div className="mb-4 text-center text-xl-left">
                      <h5
                        className="m-0 text-dark text-uppercase tracking-tight"
                        style={{
                          fontSize: "14px",
                          fontWeight: "900",
                          letterSpacing: "0.5px",
                        }}
                      >
                        <i className="fas fa-project-diagram text-success mr-2"></i>
                        Pipeline Progres Berkas Pengajuan
                      </h5>
                      <small
                        className="text-muted"
                        style={{
                          fontWeight: "700",
                          display: "block",
                          marginTop: "2px",
                        }}
                      >
                        Interaksi langsung berkas: klik tiap komponen untuk
                        membuka detail modal list data
                      </small>
                    </div>

                    <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
                      {[
                        {
                          label: "Menunggu",
                          val:
                            pilihKategori?.value === "Konsumtif"
                              ? tampilTotalPengajuan.menunggu
                              : tampilTotalPengajuanProduktif.menunggu,
                          bg: "#FFF9E6",
                          text: "#FFAF05",
                          icon: "clock",
                          click: () => setModalMenunggu(!modalMenunggu),
                        },
                        {
                          label: "Revisi",
                          val:
                            pilihKategori?.value === "Konsumtif"
                              ? tampilTotalPengajuan.revisi
                              : tampilTotalPengajuanProduktif.revisi,
                          bg: "#FFF0F2",
                          text: "#FF2B4B",
                          icon: "exclamation-circle",
                          click: () => setModalRevisi(!modalRevisi),
                        },
                        {
                          label: "Ditolak",
                          val:
                            pilihKategori?.value === "Konsumtif"
                              ? tampilTotalPengajuan.ditolak
                              : tampilTotalPengajuanProduktif.ditolak,
                          bg: "#FFEBEB",
                          text: "#E10F00",
                          icon: "times-circle",
                          click: () => setModalDitolak(!modalDitolak),
                        },
                        {
                          label: "Diproses",
                          val:
                            pilihKategori?.value === "Konsumtif"
                              ? tampilTotalPengajuan.proses
                              : tampilTotalPengajuanProduktif.proses,
                          bg: "#EEF4FF",
                          text: "#2F5597",
                          icon: "sync",
                          click: () => setModalDiproses(!modalDiproses),
                        },
                        {
                          label: "Disetujui",
                          val:
                            pilihKategori?.value === "Konsumtif"
                              ? tampilTotalPengajuan.disetujui
                              : tampilTotalPengajuanProduktif.disetujui,
                          bg: "#EBFDF2",
                          text: "#26DB53",
                          icon: "check-circle",
                          click: () => setModalDisetujui(!modalDisetujui),
                        },
                      ].map((status, i) => (
                        <div
                          key={i}
                          className="flex-fill p-3 status-pill-card-lg cursor-pointer d-flex align-items-center justify-content-between layout-pulsate-hover"
                          onClick={status.click}
                          style={{
                            backgroundColor: status.bg,
                            borderRadius: "16px",
                            minWidth: "135px",
                            border: "1px solid rgba(0,0,0,0.03)",
                          }}
                        >
                          <div>
                            <small
                              className="d-block text-dark mb-1"
                              style={{
                                fontSize: "11px",
                                fontWeight: "900",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                opacity: 0.8,
                              }}
                            >
                              {status.label}
                            </small>
                            <h3
                              className="m-0"
                              style={{
                                color: status.text,
                                fontSize: "1.9rem",
                                fontWeight: "900",
                                lineHeight: "1",
                              }}
                            >
                              {loadingPresentase ? "..." : status.val}
                            </h3>
                          </div>
                          <span
                            style={{
                              color: status.text,
                              opacity: 0.8,
                              fontSize: "22px",
                            }}
                          >
                            <i className={`fas fa-${status.icon}`}></i>
                          </span>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {/* =========================================================================
    5. VISUALISASI GRAFIK 1: REALISASI VALUE CABANG (CLEAN MINIMALIST TYPOGRAPHY)
    ========================================================================= */}
          <div
            className="bg-white p-4 mb-4 shadow-sm position-relative"
            style={{ borderRadius: "24px", border: "1px solid #EAEFF5" }}
          >
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
              <div>
                <h5
                  className="m-0 text-dark text-uppercase tracking-tight"
                  style={{
                    fontSize: "15px",
                    fontWeight: "800",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  <i className="fas fa-university mr-2 text-primary"></i>
                  REALISASI VALUE KERJA CABANG
                </h5>
                <small
                  className="text-muted"
                  style={{
                    fontWeight: "600",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  Komparatif realisasi nominal kerja operasional (Miliar IDR)
                </small>
              </div>

              {/* BUTTON DETAIL PREMIUM UPGRADE */}
              <Button
                className="px-3 py-2 text-primary font-weight-bold d-flex align-items-center btn-table-premium"
                onClick={() =>
                  !loadingPresentase && setModalDetail(!modalDetail)
                }
                disabled={loadingPresentase}
                style={{
                  backgroundColor: "#F4F7FE",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  fontSize: "12px",
                  gap: "6px",
                  transition: "all 0.2s ease",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  fontWeight: "600",
                }}
              >
                <i className="fas fa-table text-primary"></i>
                <span>Detail Tabel Cabang</span>
                <i className="fas fa-chevron-right ml-1 small opacity-50"></i>
              </Button>
            </div>

            <div className="text-center mb-3">
              <span
                className="small mx-3 text-secondary"
                style={{
                  fontWeight: "600",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <span
                  className="dot-lg mr-2"
                  style={{ backgroundColor: "#003A70" }}
                ></span>
                Pencairan
              </span>
              <span
                className="small mx-3 text-secondary"
                style={{
                  fontWeight: "600",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <span
                  className="dot-lg mr-2"
                  style={{ backgroundColor: "#FFB300" }}
                ></span>
                Target
              </span>
            </div>

            <div
              className="victory-scroll-container"
              style={{ overflowX: "auto", width: "100%" }}
            >
              <div style={{ minWidth: "800px" }}>
                <VictoryChart
                  height={280}
                  width={850}
                  domainPadding={{ x: 45 }}
                >
                  <VictoryGroup offset={14} colorScale={["#003A70", "#FFB300"]}>
                    <VictoryBar
                      data={chartData.series[0].map((yVal, index) => ({
                        x: chartData.labels[index],
                        y: yVal / 1e9,
                        raw: yVal,
                      }))}
                      barWidth={11}
                      style={{ data: { rx: 4, ry: 4 } }}
                      events={[
                        {
                          target: "data",
                          eventHandlers: {
                            onMouseEnter: (evt, props) => {
                              setTooltipPos({ x: evt.clientX, y: evt.clientY });
                              setHoveredData({
                                title: "Pencairan Cabang",
                                label: props.datum.x,
                                value: props.datum.y,
                              });
                            },
                            onMouseMove: (evt) =>
                              setTooltipPos({ x: evt.clientX, y: evt.clientY }),
                            onMouseLeave: () => setHoveredData(null),
                          },
                        },
                      ]}
                    />
                    <VictoryBar
                      data={chartData.series[1].map((yVal, index) => ({
                        x: chartData.labels[index],
                        y: yVal / 1e9,
                        raw: yVal,
                      }))}
                      barWidth={11}
                      style={{ data: { rx: 4, ry: 4 } }}
                      events={[
                        {
                          target: "data",
                          eventHandlers: {
                            onMouseEnter: (evt, props) => {
                              setTooltipPos({ x: evt.clientX, y: evt.clientY });
                              setHoveredData({
                                title: "Target Cabang",
                                label: props.datum.x,
                                value: props.datum.y,
                              });
                            },
                            onMouseMove: (evt) =>
                              setTooltipPos({ x: evt.clientX, y: evt.clientY }),
                            onMouseLeave: () => setHoveredData(null),
                          },
                        },
                      ]}
                    />
                  </VictoryGroup>

                  {/* AXIS X: ABJAD / KODE WILAYAH CABANG (MODERATED TO CLEAN SYSTEM SANS-SERIF) */}
                  <VictoryAxis
                    style={{
                      tickLabels: {
                        fontSize: "11px",
                        fontFamily:
                          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                        fontWeight: "500", // Diturunkan dari 900 ke 500 biar ramping, clean, & ga kaku
                        fill: "#475569",
                      },
                      axis: { stroke: "#E2E8F0" },
                    }}
                  />

                  <VictoryAxis
                    dependentAxis
                    style={{
                      tickLabels: {
                        fontSize: "10px",
                        fontFamily:
                          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                        fontWeight: "500",
                        fill: "#64748B",
                      },
                      axis: { stroke: "#E2E8F0" },
                      grid: { stroke: "#F1F5F9" },
                    }}
                    domain={
                      chartData.series.some((data) =>
                        data.slice(0, 10).some((yValue) => yValue !== 0),
                      )
                        ? undefined
                        : { y: [0, 1] }
                    }
                  />
                </VictoryChart>
              </div>
            </div>

            <div
              className="d-flex flex-wrap justify-content-center mt-3 pt-3 border-top"
              style={{ gap: "8px" }}
            >
              {dataGrafikCabang.map((cabang, index) => (
                <span
                  key={index}
                  className="badge bg-light text-dark border px-3 py-2"
                  style={{
                    fontSize: "11px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  <b className="text-primary" style={{ fontWeight: "800" }}>
                    {String.fromCharCode(65 + index)}
                  </b>
                  : {cabang.nama}
                </span>
              ))}
            </div>
          </div>

          {/* =========================================================================
    6. LARGE GRAPH 2: GRAFIK USER INDIVIDUAL TAHUNAN (CLEAN MINIMALIST TYPOGRAPHY)
    ========================================================================= */}
          <div
            className="bg-white p-4 shadow-sm border"
            style={{ borderRadius: "24px", borderColor: "#EAEFF5" }}
          >
            <div className="d-flex align-items-center justify-content-between mb-4">
              <div>
                <h5
                  className="m-0 text-dark text-uppercase tracking-tight"
                  style={{
                    fontSize: "15px",
                    fontWeight: "800",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  <i className="fas fa-id-card-alt mr-2 text-info"></i>GRAFIK
                  KINERJA INDIVIDUAL:{" "}
                  <span className="text-primary">{auth.nama}</span>
                </h5>
                <small
                  className="text-muted"
                  style={{
                    fontWeight: "600",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  Perbandingan komparatif data realisasi personal bulanan
                  internal (Miliar IDR)
                </small>
              </div>
              <div style={{ width: "140px" }}>
                <Select
                  className="react-select primary select-vibrant-bold"
                  classNamePrefix="react-select"
                  defaultValue={{ label: yearNow, value: yearNow }}
                  onChange={(value) => setTahun(value.value)}
                  options={listYear}
                />
              </div>
            </div>

            <div className="text-center mb-3">
              <span
                className="small mx-3 text-secondary"
                style={{
                  fontWeight: "600",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <span
                  className="dot-lg mr-2"
                  style={{ backgroundColor: "#0056B3" }}
                ></span>
                Pencairan User
              </span>
              <span
                className="small mx-3 text-secondary"
                style={{
                  fontWeight: "600",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <span
                  className="dot-lg mr-2"
                  style={{ backgroundColor: "#FF8F00" }}
                ></span>
                Target User
              </span>
            </div>

            <div
              className="victory-scroll-container"
              style={{ overflowX: "auto", width: "100%" }}
            >
              <div style={{ minWidth: "800px" }}>
                <VictoryChart
                  height={280}
                  width={850}
                  domainPadding={{ x: 45 }}
                >
                  <VictoryGroup offset={13} colorScale={["#0056B3", "#FF8F00"]}>
                    <VictoryBar
                      data={chartDataUser.series[0].map((yVal, index) => ({
                        x: chartDataUser.labels[index],
                        y: yVal / 1e9,
                        raw: yVal,
                      }))}
                      barWidth={11}
                      style={{ data: { rx: 4, ry: 4 } }}
                      events={[
                        {
                          target: "data",
                          eventHandlers: {
                            onMouseEnter: (evt, props) => {
                              setTooltipPos({ x: evt.clientX, y: evt.clientY });
                              setHoveredData({
                                title: "Pencairan User",
                                label: props.datum.x,
                                value: props.datum.y,
                              });
                            },
                            onMouseMove: (evt) =>
                              setTooltipPos({ x: evt.clientX, y: evt.clientY }),
                            onMouseLeave: () => setHoveredData(null),
                          },
                        },
                      ]}
                    />
                    <VictoryBar
                      data={chartDataUser.series[1].map((yVal, index) => ({
                        x: chartDataUser.labels[index],
                        y: yVal / 1e9,
                        raw: yVal,
                      }))}
                      barWidth={11}
                      style={{ data: { rx: 4, ry: 4 } }}
                      events={[
                        {
                          target: "data",
                          eventHandlers: {
                            onMouseEnter: (evt, props) => {
                              setTooltipPos({ x: evt.clientX, y: evt.clientY });
                              setHoveredData({
                                title: "Target User",
                                label: props.datum.x,
                                value: props.datum.y,
                              });
                            },
                            onMouseMove: (evt) =>
                              setTooltipPos({ x: evt.clientX, y: evt.clientY }),
                            onMouseLeave: () => setHoveredData(null),
                          },
                        },
                      ]}
                    />
                  </VictoryGroup>

                  {/* AXIS X: NAMA BULAN (JAN, FEB, MAR... MODERATED TO CLEAN SYSTEM SANS-SERIF) */}
                  <VictoryAxis
                    style={{
                      tickLabels: {
                        fontSize: "10px",
                        fontFamily:
                          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                        fontWeight: "500", // Ramping dan lurus, tidak kaku melebar
                        fill: "#475569",
                      },
                      axis: { stroke: "#E2E8F0" },
                    }}
                  />

                  <VictoryAxis
                    dependentAxis
                    style={{
                      tickLabels: {
                        fontSize: "10px",
                        fontFamily:
                          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                        fontWeight: "500",
                        fill: "#64748B",
                      },
                      axis: { stroke: "#E2E8F0" },
                      grid: { stroke: "#F1F5F9" },
                    }}
                    domain={
                      chartDataUser.series.some((data) =>
                        data.some((yValue) => yValue !== 0),
                      )
                        ? undefined
                        : { y: [0, 1] }
                    }
                  />
                </VictoryChart>
              </div>
            </div>
          </div>

          {/* =========================================================================
    THE FLOATING PREMIUM HTML TOOLTIP CONTAINER (CLEAN & MINIMALIST ADJUSTMENT)
    ========================================================================= */}
          {hoveredData && (
            <div
              style={{
                position: "fixed",
                top: tooltipPos.y - 75,
                left: tooltipPos.x + 15,
                backgroundColor: "#1E293B",
                color: "#FFFFFF",
                padding: "8px 12px",
                borderRadius: "8px",
                boxShadow: "0 6px 20px rgba(15, 23, 42, 0.15)",
                zIndex: 9999,
                pointerEvents: "none",
                fontFamily: "system-ui, -apple-system, sans-serif",
              }}
            >
              <div
                style={{
                  fontSize: "10px",
                  textTransform: "uppercase",
                  fontWeight: "700",
                  color: "#FFB300",
                  letterSpacing: "0.5px",
                  marginBottom: "2px",
                }}
              >
                {hoveredData.title} ({hoveredData.label})
              </div>
              <div style={{ fontSize: "14px", fontWeight: "700" }}>
                {hoveredData.value.toFixed(2)} Miliar IDR
              </div>
            </div>
          )}

          {/* =========================================================================
        7. FLOATING MANAGEMENT FEE SECTION (STANDALONE SEPARATE CARD)
        ========================================================================= */}
          {pilihKategori?.value === "Konsumtif" &&
            (auth.role === "super admin" || auth.role === "client") && (
              <div
                className="bg-white p-4 shadow-xs border-0 mt-3"
                style={{ borderRadius: "20px" }}
              >
                <div className="d-flex flex-wrap justify-content-between align-items-center pb-3 mb-3 border-bottom">
                  <div>
                    <h5 className="font-weight-bold text-dark m-0">
                      <i className="fas fa-hand-holding-usd text-success mr-2"></i>
                      REKAPITULASI MANAGEMENT FEE
                    </h5>
                    <small className="text-muted">
                      Kalkulasi pembagian komisi operasional bulanan
                    </small>
                  </div>
                  <div
                    className="d-flex flex-wrap align-items-center mt-2 mt-md-0"
                    style={{ gap: "12px" }}
                  >
                    <ReactDatetime
                      className="rdt-upward"
                      dateFormat="MMMM YYYY"
                      timeFormat={false}
                      onChange={handleDateChange}
                      value={new Date(tglManagementFee)}
                      renderInput={(props, openCalendar) => (
                        <Button
                          className="border bg-light text-dark font-weight-bold shadow-none px-3 btn-sm"
                          onClick={openCalendar}
                          style={{ borderRadius: "8px" }}
                        >
                          <i className="far fa-calendar-check mr-2 text-primary"></i>
                          {moment(tglManagementFee).format("MMMM YYYY")}
                        </Button>
                      )}
                    />
                    <div
                      className="px-3 py-2 text-right bg-net-volume-pill"
                      style={{ borderRadius: "10px" }}
                    >
                      <small
                        className="text-muted d-block font-weight-bold"
                        style={{ fontSize: "9px", textTransform: "uppercase" }}
                      >
                        Net Fee Volume
                      </small>
                      <span
                        className="font-weight-bold text-dark"
                        style={{ fontWeight: "900", fontSize: "15px" }}
                      >
                        {formatRupiah(
                          pilihKategori?.value === "Konsumtif"
                            ? total
                            : totalProduktif,
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
                  {(pilihKategori?.value === "Konsumtif"
                    ? items
                    : itemsProduktif
                  ).map((item, index) => (
                    <div
                      key={index}
                      className="flex-fill bg-light p-3 text-center transition-card"
                      style={{
                        borderRadius: "14px",
                        minWidth: "150px",
                        border: "1px dashed #cbd5e1",
                      }}
                    >
                      <small
                        className="text-muted font-weight-bold d-block mb-1 text-uppercase"
                        style={{ fontSize: "10px" }}
                      >
                        {item.title}
                      </small>
                      {loadingPresentase ? (
                        <Skeleton width={90} />
                      ) : (
                        <span
                          className="font-weight-bold text-dark"
                          style={{ fontWeight: "900", fontSize: "14px" }}
                        >
                          {formatRupiah(item.result)}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
        </Container>
      </Card>
    </>
  );
}

export default DashboardUtama;
